import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Icon, Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';

import { InputField, Select } from 'Common/SemanticWrapper';
import { PreparationInstructionEnum as Fields } from 'Common/FieldEnum';
import { HACCP_POSITION_OPTIONS } from 'Pages/managerecipe/helpers/constants';

class HACCPModal extends Component {
  static propTypes = {
    headerTitle: PropTypes.string.isRequired,
    modalProps: PropTypes.shape({
      open: PropTypes.bool.isRequired,
      onClose: PropTypes.func.isRequired,
      size: PropTypes.string,
    }),
  };

  render() {
    const {
      headerTitle,
      modalProps,
      instruction,
      haccpOptions,
      haccpTypeOptions,
      handleAddHACCPClicked,
    } = this.props;

    return (
      <Modal {...modalProps}>
        <Modal.Header className="manage-menu-modal-header ">
          {headerTitle}
          <Icon
            name="close"
            onClick={modalProps.onClose}
            style={{ cursor: 'pointer' }}
          />
        </Modal.Header>
        <Modal.Content className="manage-menu-modal-content">
          <Grid columns="equal">
            <Grid.Row>
              <Grid.Column>
                <Field
                  component={Select}
                  label={'HACCP Position'}
                  name={Fields.Position}
                  fluid
                  options={HACCP_POSITION_OPTIONS}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  component={Select}
                  label={'HACCP Type'}
                  name={Fields.TypeId}
                  fluid
                  options={haccpTypeOptions}
                  usePortal={true}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  component={Select}
                  label={'HACCP Critical Limit'}
                  name={Fields.HACCPCriticalLimitId}
                  fluid
                  options={haccpOptions}
                  usePortal={true}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Field
                  component={InputField}
                  label={'HACCP Notes'}
                  name={Fields.HACCPNotes}
                  fluid
                  showOnlyTouchedError
                  hideEmptyError
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Button
                  floated="right"
                  style={{ marginTop: 10 }}
                  onClick={() => handleAddHACCPClicked(instruction)}
                >
                  Add
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}

export { HACCPModal };



// WEBPACK FOOTER //
// ./src/pages/managerecipe/components/PreparationInstructions/HACCPModal.js